import { slackTeamIdSchema } from "./slackChannels.ts";

/**
 * The Statsig gate for Sign in with Slack: the button on the sign-in page and
 * creating an account with it. Sign-in for an existing account stays open.
 *
 * Evaluated before an account exists, so it is a global on/off switch — see
 * `checkSignupGate`. Fails closed: an unrecognised gate reads false.
 */
export const SLACK_SIGNUP_GATE = "slack-signup";

/**
 * Where Sign in with Slack lives: `/options`, `/base` (start), and the
 * callback at the path itself.
 *
 * Under the Slack connector's own callback, `/api/p/auth/oauth/slack`, because
 * Slack accepts a `redirect_uri` below any redirect URL the app registers. So
 * sign-in needs no Redirect URL of its own in any environment's Slack app.
 */
export const SLACK_SIGN_IN_PATH = "/api/p/auth/oauth/slack/signin";

export type SlackSignInOptionsResp = { enabled: boolean };

/**
 * The query param the Slack sign-in callback adds to a brand-new account's
 * result URL: the workspace it signed in with, for the client to send the
 * Slack install to next. A public workspace id, never a credential.
 */
export const SLACK_INSTALL_TEAM_PARAM = "slack_install_team";

/**
 * The `error` a Slack sign-up ends with when its reported email is already an
 * okthx member's sign-up address. The sign-up stops instead of minting a second
 * account, and the person is told to sign in the way they did before.
 */
export const SLACK_EMAIL_HAS_ACCOUNT = "slack_email_has_account";

/** The query param the Slack install start reads to pin the install to a workspace. */
export const SLACK_INSTALL_TEAM_QUERY = "team";

/**
 * The Slack install start for the workspace a sign-up named, or undefined when
 * the value is not a workspace id. The path is fixed here; only a validated
 * workspace id ever comes from the link.
 */
export function slackInstallPath(teamParam: string | null | undefined): string | undefined {
  const team = slackTeamIdSchema.safeParse(teamParam);
  if (!team.success) return undefined;
  const query = new URLSearchParams({ [SLACK_INSTALL_TEAM_QUERY]: team.data });
  return `/api/a/auth/oauth/slack/connect?${query.toString()}`;
}
